import {Palette} from 'hubbl-shared';
import {memo} from 'react';
import styled, {css} from 'styled-components';
import {TextHeading5} from '../../text/TextHeading5';

// Define styles for the Button with dynamic behavior for compact mode
const Button = styled.button<{
  isCompact?: boolean;
  customWidth?: number;
  isDisabled?: boolean;
  fullWidth?: boolean;
}>`
  background-color: ${({isDisabled}) =>
    isDisabled ? Palette.almostBlack500 : Palette.almostBlack};
  color: ${Palette.white};
  height: ${({isCompact}) => (isCompact ? '36px' : '48px')};
  width: ${({isCompact, customWidth, fullWidth}) =>
    fullWidth
      ? '100%'
      : customWidth
        ? `${customWidth}px`
        : isCompact
          ? '140px'
          : '180px'};
  border-radius: ${({isCompact}) => (isCompact ? '16px' : '20px')};
  border-width: 0px;
  outline: 0;
  cursor: pointer;
  transition:
    ease background-color 250ms,
    transform 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  &:disabled {
    cursor: default;
    opacity: 0.7;
  }

  ${({isCompact}) =>
    isCompact &&
    css`
      font-size: 14px;
      padding: 0 10px;
    `}
`;

interface PrimaryButtonProps {
  onClick: () => void;
  label: string;
  isCompact?: boolean; // New prop to toggle compact mode
  customWidth?: number;
  isDisabled?: boolean;
  fullWidth?: boolean; // New prop to make button take full width of container
}

export const PrimaryButton = memo(
  ({
    label,
    onClick,
    isCompact = false,
    customWidth,
    isDisabled,
    fullWidth = false,
  }: PrimaryButtonProps) => {
    return (
      <Button
        disabled={isDisabled}
        onClick={isDisabled ? undefined : onClick}
        isCompact={isCompact}
        customWidth={customWidth}
        fullWidth={fullWidth}>
        <TextHeading5
          text={label}
          color={Palette.white}
          style={{
            fontSize: isCompact ? '12px' : 'inherit', // Adjust font size in compact mode
          }}
        />
      </Button>
    );
  },
);
